
export default function Solution() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 md:gap-16 items-center">
          <div className="lg:col-span-2 space-y-4 md:space-y-6">
            <div className="inline-block">
              <span className="text-xs md:text-sm font-medium text-primary bg-primary/5 px-3 md:px-4 py-1.5 md:py-2 rounded-full whitespace-nowrap">
                ECオートパイロットOSの考え方
              </span>
            </div>
            
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight">
              <strong className="text-primary">"ツール"</strong>ではなく、<br />
              <strong className="text-primary">"業務設計"</strong>
            </h2>
            
            <div className="space-y-4 md:space-y-6 text-sm md:text-lg text-gray-700 leading-relaxed">
              <p>
                <strong className="text-gray-900">「判断を数式化」</strong><br />
                仕入れ可否、価格設定、利益計算など、これまで"感覚"で行っていた判断を、明確なルールと数式に落とし込みます。
              </p>
              
              <p>
                <strong className="text-gray-900">「作業をフロー化」</strong><br />
                データの流れを整理し、人が介入すべきポイントと自動化できるポイントを明確に分離します。
              </p>
              
              <p>
                <strong className="text-gray-900">「Googleスプレッドシート中心の運用OS」</strong><br />
                高額なツールではなく、誰でも使えるスプレッドシートを中心に、EC運営全体を"回る仕組み"として再構築します。
              </p>
            </div>
          </div>
          
          <div className="lg:col-span-3">
            <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-2xl p-5 md:p-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
                仕組みの全体像
              </h3>
              
              <div className="flex flex-col gap-3 md:gap-4">
                <div className="flex items-center gap-2 md:gap-4">
                  <div className="flex-1 bg-primary text-white rounded-xl px-3 md:px-6 py-3 md:py-4 text-center font-bold shadow-md text-xs md:text-base">
                    仕入れデータ
                  </div>
                  <i className="ri-arrow-right-line text-xl md:text-3xl text-primary"></i>
                  <div className="flex-1 bg-primary text-white rounded-xl px-3 md:px-6 py-3 md:py-4 text-center font-bold shadow-md text-xs md:text-base">
                    スプレッドシート
                  </div>
                </div>
                
                <div className="text-center text-xs md:text-sm text-gray-600 -my-1 md:-my-2">
                  利益計算 / 可否判定
                </div>
                
                <div className="flex items-center gap-2 md:gap-4">
                  <div className="flex-1"></div>
                  <i className="ri-arrow-down-line text-xl md:text-3xl text-primary"></i>
                  <div className="flex-1"></div>
                </div>
                
                <div className="flex items-center gap-2 md:gap-4">
                  <div className="flex-1 bg-primary text-white rounded-xl px-3 md:px-6 py-3 md:py-4 text-center font-bold shadow-md text-xs md:text-base">
                    出品データ生成
                  </div>
                  <i className="ri-arrow-right-line text-xl md:text-3xl text-primary"></i>
                  <div className="flex-1 bg-primary text-white rounded-xl px-3 md:px-6 py-3 md:py-4 text-center font-bold shadow-md text-xs md:text-base">
                    モール反映
                  </div>
                </div>
                
                <div className="text-center text-xs md:text-sm text-gray-600 -my-1 md:-my-2">
                  CSV / API連携
                </div>
                
                <div className="flex items-center gap-2 md:gap-4">
                  <div className="flex-1"></div>
                  <i className="ri-arrow-down-line text-xl md:text-3xl text-primary"></i>
                  <div className="flex-1"></div>
                </div>
                
                <div className="bg-primary text-white rounded-xl px-3 md:px-6 py-3 md:py-4 text-center font-bold shadow-md text-xs md:text-base">
                  在庫同期
                </div>
                
                <div className="text-center text-xs md:text-sm text-gray-600 mt-1 md:mt-2">
                  複数モール間で自動同期
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
